import restApi from './hotelsApiService'

const hotelsService = {}

hotelsService.getAll = async VUE_APP_BUDGET_ID => {
  try {
    const res = await restApi.get(`?budgetUuid=${VUE_APP_BUDGET_ID}&loadDeepInfo=1`)
    return res.data.data[0]
  } catch (err) {
    throw new Error(err)
  }
}

export default hotelsService
